<template>
  <div class="dashboard">
    <div class="global-toolbar">
      <GridSearch
        :searchHeader="searchHeader"
        :searchPlaceholder="searchPlaceholder"
        class="global-search"
        @searchSubmit="searchSubmit"
      />
      <span title="Clear All Filters" class="k-button k-primary toolbar-button" @click="globalClearAllFilters">
        Clear All Filters
      </span>
      <span title="Clear Search" class="k-button k-primary toolbar-button" @click="globalClearSearch">
        Clear Search
      </span>
      <span
        title="Clear All Filters And Search"
        class="k-button k-primary toolbar-button"
        @click="globalClearAllFiltersAndSearch"
      >
        Clear All Filters and Search
      </span>
    </div>
    <div class="grids">
      <div class="shrinkable-grids">
        <CustomerGrid v-if="query" />
        <UnitGrid v-if="query" />
      </div>
      <OilSampleGrid />
      <CoolantSampleGrid />
      <div class="no-search-results" v-if="noSearchResults">
        <p>No results matched your search query or filters.</p>
      </div>
    </div>
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-wrapper">
        <RingLoader class="loading-spinner" :color="'#F6F6F6'" />
      </div>
    </div>
  </div>
</template>

<script>
import RingLoader from '../shared/RingLoader.vue';
import EventBus from '../../../event-bus';

import Constants from '../../constants/constants';

import CustomerGrid from '../customer/CustomerGrid.vue';
import UnitGrid from '../unit/UnitGrid.vue';
import OilSampleGrid from '../oil-sample/OilSampleGrid.vue';
import CoolantSampleGrid from '../coolant-sample/CoolantSampleGrid.vue';
import GridSearch from '../shared/GridSearch.vue';

export default {
  name: 'Dashboard',
  data() {
    return {
      searchHeader: Constants.Dashboard.searchHeader,
      searchPlaceholder: Constants.Dashboard.searchPlaceholder,
      isLoading: 0,
      query: '',
      noSearchResults: false
    };
  },
  components: {
    CustomerGrid,
    UnitGrid,
    OilSampleGrid,
    CoolantSampleGrid,
    GridSearch,
    RingLoader
  },
  methods: {
    searchSubmit(query, isActive) {
      this.query = query;
      this.$nextTick(() => {
        EventBus.$emit(Constants.EventBus.globalSearchSubmit, query, isActive);
      });
    },
    globalClearAllFilters() {
      EventBus.$emit(Constants.EventBus.globalClearAllFilters);
    },
    globalClearSearch() {
      EventBus.$emit(Constants.EventBus.globalClearSearch);
    },
    globalClearAllFiltersAndSearch() {
      EventBus.$emit(Constants.EventBus.globalClearAllFilters);
      EventBus.$emit(Constants.EventBus.globalClearSearch);
    }
  },
  created() {
    EventBus.$on(Constants.EventBus.isLoading, isLoading => {
      if (isLoading) {
        this.isLoading += 1;
      } else {
        this.isLoading ? (this.isLoading -= 1) : (this.isLoading = 0);
      }

      this.noSearchResults = Array.from(document.getElementsByClassName('grid')).every(
        element => element.style.display === 'none'
      );
    });
  },
  updated() {
    EventBus.$emit(Constants.EventBus.isGlobalSearchActive, true);
  },
  destroyed() {
    EventBus.$emit(Constants.EventBus.isGlobalSearchActive, false);
  }
};
</script>

<style lang="scss" scoped>
.dashboard {
  .no-search-results,
  .global-toolbar {
    padding: 10px 20px;
  }

  .grids {
    display: flex;
    flex-flow: row wrap;

    .shrinkable-grids {
      display: flex;
      flex-flow: row wrap;
      width: 100%;

      [grid-type='customers-grid'],
      [grid-type='units-grid'] {
        flex: 1 1 50%;
        min-width: 50%;
        display: flex;

        :deep(.k-widget.k-grid) {
          // Subtract padding
          height: calc(100% - 40px) !important;
        }
      }
    }

    .grid {
      height: auto;
      padding-top: 0;
    }
  }

  .loading-overlay {
    background: rgba(0, 0, 0, 0.5);
    bottom: 0;
    height: 100vh;
    position: fixed;
    right: 0;
    top: 0;
    width: calc(100% - 250px);
    z-index: 10000;

    .loading-wrapper {
      height: 100%;
      position: relative;
      width: 100%;

      .loading-spinner {
        left: 50%;
        margin-right: -50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);

        :deep(div) {
          // Overrides default value from the loader component.
          border-color: $white-offset transparent transparent !important;
        }
      }
    }
  }
}
</style>
